import { hasPendingAction } from './pendingAction';
import { isServiceReason } from './serviceApplications';

export const resolvePostAuthPath = (searchParams) => {
  const reason = searchParams?.get?.('reason');
  if (isServiceReason(reason) || hasPendingAction()) return '/';
  const next = searchParams?.get?.('next');
  if (next && next.startsWith('/') && !next.startsWith('//')) return next;
  return '/dashboard/inquiries';
};
